import axios from "axios";

export const admin_service_status_toggle_mixin = {
  data() {
    return {
      last_confirmed_action: null
    };
  },
  methods: {
    may_show_service_status_change_dialog(status, service) {
      const allowed_status = [1, -1, -2, "1", "-1", "-2"];
      if (allowed_status.indexOf(status) == -1) {
        return;
      }

      this.last_confirmed_action = null;

      if (this.$options.name == "ServiceList" && status != 1) {
        this.service_overflow_menu_details.open_menu_id = null;
      }

      let delete_disable_str =
        "<ul class='bull'><li>" +
        this.T__("Existing bookings will NOT be affected.") +
        "</li><li>" +
        this.T__("New booking and rescheduling will NOT be allowed.") +
        "</li><li>" +
        this.T__("Cancellation will be allowed.") +
        "</li></ul>";

      let status_action_str = this.T__("turn on");
      let button_str = this.T__("Turn On");
      let detail_str = "";
      let title_str = "";
      if (status == -1) {
        status_action_str = this.T__("turn off");
        button_str = this.T__("Yes, turn off.");
        detail_str =
          delete_disable_str +
          '<span class="wpcal_fix_service_disable_attempt"></span>';
        title_str = "Turn off " + service.name + "?";
      } else if (status == -2) {
        status_action_str = "delete";
        button_str = this.T__("Yes, delete.");
        detail_str = delete_disable_str;
        title_str = "Delete " + service.name + "?";
      } else if (status == 1) {
        this.change_service_status(status, service);
        return;
      }

      this.$modal.show("dialog", {
        title: title_str,
        text: detail_str,
        buttons: [
          {
            title: button_str,
            class:
              status == -1 || status == -2
                ? "vue-dialog-button dialog-red-btn"
                : "",
            handler: () => {
              this.change_service_status(status, service);
              this.last_confirmed_action = status == -1 ? "disable" : null;
              this.$modal.hide("dialog");
            }
          },
          {
            title: this.T__("No, don't."),
            default: true, // Will be triggered by default if 'Enter' pressed.
            handler: () => {
              this.load_page();
              this.$modal.hide("dialog");
            }
          }
        ]
      });
    },
    change_service_status(status, service) {
      let wpcal_request = {};

      let action_update_status = "update_service_status_of_current_admin";
      wpcal_request[action_update_status] = {
        service_id: service.id,
        status: status
      };

      let action_get_services = "get_managed_services_for_current_admin";
      if (this.$options.name == "ServiceList") {
        wpcal_request[action_get_services] = this.filter_options;
      }

      let action_edit_service = "edit_service";
      if (this.$options.name == "ServiceForm") {
        wpcal_request[action_edit_service] = {
          service_id: this.service_id
        };
      }

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          this.notify_single_action_result(
            response.data[action_update_status],
            {
              dont_notify_success: true
            }
          );

          if (this.$options.name == "ServiceList") {
            this.notify_single_action_result(
              response.data[action_get_services],
              {
                dont_notify_success: true
              }
            );
            if (
              response.data &&
              response.data[action_get_services].hasOwnProperty("service_list")
            ) {
              this.service_list =
                response.data[action_get_services].service_list;
            }
          }

          if (this.$options.name == "ServiceForm") {
            if (
              response.data &&
              response.data[action_edit_service].hasOwnProperty("service_data")
            ) {
              this.form = response.data[action_edit_service].service_data;
              this.saved_form = this.clone_deep(this.form);
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    this.event_bus.$on("dialog-before-closed", event => {
      if (
        event?.ref &&
        event.ref.querySelector(".wpcal_fix_service_disable_attempt")
      ) {
        if (
          this.$options.name == "ServiceList" &&
          this.last_confirmed_action !=
            "disable" /* this.last_confirmed_action == "disable" UI purpose, on click toggle the whole Service shows in disabled feel, before confirming in the popup, after confirming yes or no, below code runs it goes back to active, once ajax call over comes back to disabled again to avoid flip flop this is done */
        ) {
          this.service_list = this.clone_deep(this.saved_service_list);
        } else if (this.$options.name == "ServiceForm") {
          this.form = this.clone_deep(this.saved_form);
        }
      }
    });
  }
};
